import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Fade from '@material-ui/core/Fade'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'

// store
import { Context } from '../store'

// images
import placeIcon from '../images/place_black_24dp 1.svg'

import { t } from 'application-translator/dist/translate/translate.react.js';

// styles
const useStyles = makeStyles({
  clubSection: {
    display: 'grid',
    gap: '1rem',
    placeItems: 'center',
    position: 'relative',

    '& a': {
      textDecoration: 'none',
    },
  },
  address: {
    display: 'grid',
    gap: '.75rem',
    placeItems: 'center',
    color: 'rgba(117, 117, 117, 1)',
    padding: '0 1.5rem 1rem',
  },
})

function ClubDetails({ club = '', address = '', isLoading =  true }) {
  const classes = useStyles()

  const { globalState } = useContext(Context)
  const clubId = globalState.clubData.id

  return (
    <>
      {club && address ? (
        <Fade in={true} timeout={1000}>
          <div className={classes.clubSection}>
            <h1>{club}</h1>
            <div className={classes.address}>
              <img src={placeIcon} alt="" />
              <p>{address}</p>
            </div>
            
            <Link to={`/links/${clubId}/here-now`}>
              <Button variant="contained" color="primary">
                {t('I\'m here now')}
              </Button>
            </Link>
          </div>
        </Fade>
      ) : isLoading ? (
        <Box padding={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Box padding={4}>
          <h1>Club Not Found</h1>
        </Box>
      )}
    </>
  )
}

export default ClubDetails
